import React, { Component } from 'react';

export default function wrapper(WrappedComponent: any) {
  class Wrapper extends Component<any> {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return Wrapper;
}
